var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.25H9.115C8.8 1.38 7.975 0.75 7 0.75C6.025 0.75 5.2 1.38 4.885 2.25H1.75C0.925 2.25 0.25 2.925 0.25 3.75V14.25C0.25 15.075 0.925 15.75 1.75 15.75H12.25C13.075 15.75 13.75 15.075 13.75 14.25V3.75C13.75 2.925 13.075 2.25 12.25 2.25ZM7 2.25C7.4125 2.25 7.75 2.5875 7.75 3C7.75 3.4125 7.4125 3.75 7 3.75C6.5875 3.75 6.25 3.4125 6.25 3C6.25 2.5875 6.5875 2.25 7 2.25ZM7 5.25C8.245 5.25 9.25 6.255 9.25 7.5C9.25 8.745 8.245 9.75 7 9.75C5.755 9.75 4.75 8.745 4.75 7.5C4.75 6.255 5.755 5.25 7 5.25ZM11.5 14.25H2.5V13.2C2.5 11.7 5.5 10.875 7 10.875C8.5 10.875 11.5 11.7 11.5 13.2V14.25Z",
    fill: "#377FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assign-icon.cc441112af46711741e2993dbdc67f25.svg";
export { ForwardRef as ReactComponent };